// extracted by mini-css-extract-plugin
module.exports = {"container":"ResultsTileList_container__3iU3e","heading":"ResultsTileList_heading__R6-qX"};